import { useMemo } from 'react';

const useAdminRoles = () => useMemo(() => ['admin', 'system'], []);

export default useAdminRoles;